<template>
  <v-list-item @click="$emit('click')">
    <ButtonIconTooltip
      v-if="icon"
      :icon="icon"
      :tooltip="title"
      :color="color"
      flat
    />
    <v-list-item-title>
      <span :style="{color:titleColor}">{{ title }}</span>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import ButtonIconTooltip from '@/components/shared/widgets/ButtonIconTooltip';

export default {
    components: {
        ButtonIconTooltip,
    },
    props: {
        icon: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: null,
        },
        titleColor: {
            type: String,
            default: null,
        },
    },
};
</script>
